import {
  useBookingsCreatingStore,
  useBookingsEditingStore,
  useBookingsStore,
  useDateStore,
  useZoomStore,
} from "../../../../stores/planner";
import { getCellWidthForZoom, getNumberOfDays, OffsetDays } from "../../../../lib/DateUtils";
import { usersMaxScheduleTime } from "../../../../lib/PlannerUtils";
import $ from "jquery";
import { DateTime } from "luxon";
import { useProfileStore } from "../../../../stores/profileStore";
import { useNotificationStore } from "../../../../stores/notificationStore";

class PlannerActions {
  #userIndexStart = null;
  #userDateStart = null;
  #clickStartX = null;
  #clickStartY = null;
  #formatMapping = {
    0: 5,
    1: 10,
    2: 15,
    3: 30,
  };
  #userIndexEnd = null;
  #userDateEnd = null;
  #id = Date.now() % 10000;
  #multipleCreation = false;

  // eslint-disable-next-line no-unused-vars
  mouseUped(offsetX, offsetY, users, e) {}

  // eslint-disable-next-line no-unused-vars
  mouseMoved(offsetX, offsetY, users) {}

  // eslint-disable-next-line no-unused-vars
  mouseDowned(offsetX, offsetY, users) {}

  get formatMapping() {
    return this.#formatMapping;
  }

  get userIndexStart() {
    return this.#userIndexStart;
  }
  set userIndexStart(userIndex) {
    this.#userIndexStart = userIndex;
  }

  get userDateStart() {
    return this.#userDateStart;
  }
  set userDateStart(dateStart) {
    this.#userDateStart = dateStart;
  }

  get clickStartX() {
    return this.#clickStartX;
  }
  set clickStartX(position) {
    this.#clickStartX = position;
  }

  get clickStartY() {
    return this.#clickStartY;
  }
  set clickStartY(position) {
    this.#clickStartY = position;
  }

  get userIndexEnd() {
    return this.#userIndexEnd;
  }
  set userIndexEnd(newIndex) {
    this.#userIndexEnd = newIndex;
  }

  get userDateEnd() {
    return this.#userDateEnd;
  }
  set userDateEnd(newDate) {
    this.#userDateEnd = newDate;
  }

  get multipleCreation() {
    return this.#multipleCreation;
  }
  set multipleCreation(newValue) {
    this.#multipleCreation = newValue;
  }

  get id() {
    return this.#id;
  }

  getBookingById = (id) => useBookingsStore.getState().bookings.find((b) => b.id === id);

  //TODO: weekendsHidden into storage
  //TODO: bookingFormat into storage
  calculateUserDateStart = (offsetX, offsetY, users, weekendsHidden, bookingFormat) => {
    const weekendWidth = weekendsHidden ? 10 : getCellWidthForZoom(useZoomStore.getState().zoom);
    const dayWidth = getCellWidthForZoom(useZoomStore.getState().zoom);
    let currentHeight = 0;
    const userHeights = users.map(
      (user) => (usersMaxScheduleTime(user) / 60) * this.#formatMapping[bookingFormat] + 17
    );

    userHeights.forEach((userHeight, index) => {
      if (
        currentHeight < offsetY + $("#planner-scroll-list").scrollTop() &&
        currentHeight + userHeight > offsetY + $("#planner-scroll-list").scrollTop()
      ) {
        this.#userIndexStart = index;

        let calculatedOffsetX = 0;
        let dateIteration = 0;

        while (calculatedOffsetX < offsetX + $("#planner-scroll-list").scrollLeft()) {
          calculatedOffsetX += dateIteration % 7 < 5 ? dayWidth : weekendWidth;
          dateIteration++;
        }

        this.#userDateStart = OffsetDays(useDateStore.getState().date, dateIteration - 1);
      }

      currentHeight += userHeight;
    });
  };

  redrawCreationBookings = (weekendsHidden) => {
    let creationBookings = [];
    useBookingsCreatingStore.getState().setBookingsDragCreation(false);

    for (let i = this.userIndexStart; i <= this.userIndexEnd; i++) {
      let dateDiff = getNumberOfDays(this.userDateStart, this.userDateEnd);

      for (let j = 0; j <= dateDiff; j++) {
        if (j > 0 || i > this.userIndexStart) {
          useBookingsCreatingStore.getState().setBookingsDragCreation(true);
        }

        if (
          (weekendsHidden && OffsetDays(this.userDateStart, j).getDay() === 0) ||
          (weekendsHidden && OffsetDays(this.userDateStart, j).getDay() === 6)
        ) {
          continue;
        }

        creationBookings.push([i, OffsetDays(this.userDateStart, j)]);
      }
    }

    return creationBookings;
  };

  moveBookingAction = (
    hash,
    plannerDispatcher,
    setBookings,
    closeEditWindow,
    teams,
    teamId,
    usersRef,
    getUserIndex,
    setBookingsEditingQuestionProps,
    moveBookingsRequest,
    t
  ) => {
    const bookingsEditing = useBookingsEditingStore.getState().bookingsEditing;
    const realMovingBookings = bookingsEditing.length === 0 ? [hash.booking] : bookingsEditing;
    const role = localStorage.getItem("tb-role") || "regular";
    const makeRequest = (moveRepetition) =>
      moveBookingsRequest(
        bookingsEditing,
        hash,
        moveRepetition,
        plannerDispatcher,
        setBookings,
        closeEditWindow,
        teams,
        teamId,
        usersRef,
        getUserIndex,
        t
      );

    if (role === "self_planner" && hash.to_user?.id !== useProfileStore.getState().profile.id) {
      useNotificationStore.getState().setInAppNotification(t("notifications.planning.self_planner_creating_error"));
      return;
    }

    if (realMovingBookings.some((b) => b.repetition !== null)) {
      if (realMovingBookings.every((b) => b.repetition?.id === realMovingBookings[0].repetition?.id)) {
        if (realMovingBookings.every((b) => b.user_id === realMovingBookings[0].user_id)) {
          const firstDate = realMovingBookings.sort((a, b) =>
            DateTime.fromISO(a.date) > DateTime.fromISO(b.date) ? 1 : -1
          )[0].date;

          setBookingsEditingQuestionProps({
            open: true,
            title: "Repetition moving",
            text: `Do you want to move all bookings from repetition series to be moved, starting from ${firstDate} to user ${hash.to_user?.name}?`,
            yesCallback: () => makeRequest("move"),
            noCallback: () => makeRequest("disconnect"),
          });
        } else {
          alert("You can only move repetition bookings of same user");
        }
      } else {
        alert("You can only move bookings from same repetition series");
      }
    } else {
      makeRequest("default");
    }
  };
}

export default PlannerActions;
